export interface UtilsStoreState {
    isInitThirdPartyTools: boolean;
    isOpenHomeBlogBanner: boolean;
    // 쿠키 배너에서 저장된 Functional 동의 신호. null = 이 세션에서 아직 변경 없음.
    // 채널톡 플러그인(8.channelTalk.client.ts)이 watch하여 boot/shutdown 한다.
    functionalConsent: boolean | null;

    blockedEmailDomains: string[];
    blockedEmailDomainsLoading: boolean;
    blockedEmailDomainsLoaded: boolean;
    blockedEmailDomainsError: string | null;
}

export const state = () => ({
    isInitThirdPartyTools: false,
    isOpenHomeBlogBanner: true,
    functionalConsent: null as boolean | null,

    blockedEmailDomains: [] as string[],
    blockedEmailDomainsLoading: false,
    blockedEmailDomainsLoaded: false,
    blockedEmailDomainsError: null as string | null,
});
